import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import MLReinstatePolicyPage from './pages/MLReinstatePolicy/MLReinstatePolicyPage';
import MLReinstatementConfirmationPage from './pages/MLReinstatementConfirmation/MLReinstatementConfirmationPage';

setComponentMapOverrides(
    {
        MLReinstatePolicyPage: { component: 'MLReinstatePolicyPage' },
        MLReinstatementConfirmationPage: { component: 'MLReinstatementConfirmationPage' }
    },
    {
        MLReinstatePolicyPage,
        MLReinstatementConfirmationPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as ReinstatementWizardMessages } from './ReinstatementWizard.messages';
export { default as ReinstatementWizard } from './ReinstatementWizard';
export { default as Reinstatement } from './model/Reinstatement';
export { default as MLReinstatementContactUsPage } from './pages/MLReinstatementContactUs/MLReinstatementContactUsPage';
